import { useState } from "react";
import Fab from "@mui/material/Fab";

export function TestimonialCarousel(props) {
   const [currentImg, setCurrentImg] = useState("./assets/media/Variant4.png");
   const testimonials = [
      "./assets/media/Variant4.png",
      "./assets/media/Component 22.png",
      "./assets/media/Variant5.png",
      "./assets/media/Component 22 (1).png",
      "./assets/media/Component 23.png",
      "./assets/media/Component 24.png",
      "./assets/media/Component 27.png",
   ];


   return (
      <div
         className="gradient-2"
         style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
         }}
      >
         <Fab
            sx={{
               backgroundColor: "#464D52",
               "&:hover": { backgroundColor: "#464D52 !important" },
            }}
            onClick={(e) => {
               for (let i = 0; i < testimonials.length; i++) {
                  if (currentImg === testimonials[i] && i !== 0) {
                     setCurrentImg(testimonials[i - 1]);
                  } else {
                     if (currentImg === testimonials[i] && i === 0) {
                        setCurrentImg(testimonials[testimonials.length - 1]);
                     }
                  }
               }
            }}
         >
            <img
               alt='Vector'
               src={"./assets/media/Vector (4).png"}
               style={{ objectFit: "scale-down" }}
            />
         </Fab>
         <img
            alt='testimonial-img'

            className='testimonial-img'
            src={currentImg}
            style={{ width: window.innerWidth < 768 ? "75%" : "" }}
         />
         <Fab
            sx={{
               backgroundColor: "#464D52",
               "&:hover": { backgroundColor: "#464D52 !important" },
            }}
            onClick={(e) => {
               for (let i = 0; i < testimonials.length; i++) {
                  if (
                     currentImg === testimonials[i] &&
                     i !== testimonials.length - 1
                  ) {
                     setCurrentImg(testimonials[i + 1]);
                  } else {
                     if (
                        currentImg === testimonials[i] &&
                        i === testimonials.length - 1
                     ) {
                        setCurrentImg(testimonials[0]);
                     }
                  }
               }

            }}
         >
            <img
               alt='Vector'

               src={"./assets/media/Vector (3).png"}
               style={{ objectFit: "scale-down" }}
            />
         </Fab>
      </div>
   );
}
